import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import ButtonStyles from '@stories/Components/Buttons/Button/Button.styles';
import styled from 'styled-components';
const Container = styled.nav `
  --buttonBgColour: ${brand.global.black};
  --buttonFgColour: ${brand.global.white};

  display: flex;
  align-items: center;
  column-gap: ${fluid(12, 16)};

  ${ButtonStyles.Container}[data-prev] {
    transform: scaleX(-1);
  }
`;
const ControlsStyles = {
    Container,
};
export default ControlsStyles;
